import { render, staticRenderFns } from "./CambioContrasea.vue?vue&type=template&id=448341bc"
import script from "./CambioContrasea.vue?vue&type=script&lang=js"
export * from "./CambioContrasea.vue?vue&type=script&lang=js"
import style0 from "./CambioContrasea.vue?vue&type=style&index=0&id=448341bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports